export default __webpack_public_path__ + "static/media/appStore.2feae9b0.png";